import { Field } from '@kanda-libs/ks-component-ts';
import useEnquiryWorkDetailsFieldsWork from './useEnquiryWorkDetailsFieldsWork';

const EnquiryWorkDetailsFormFieldsWorkWorkType: React.FunctionComponent =
  function ({}) {
    const { workTypeOptions, workTypeValidation } =
      useEnquiryWorkDetailsFieldsWork();
    return (
      <Field.Validator validation={workTypeValidation}>
        <Field.Select
          name="job_info.work_type"
          options={workTypeOptions}
          placeholder="Select..."
          label="Type of Work"
        />
      </Field.Validator>
    );
  };

export default EnquiryWorkDetailsFormFieldsWorkWorkType;
